module.exports = __webpack_public_path__ + "img/growth.30c24b7d.svg";